import { Box, TextField, Typography, IconButton } from '@mui/material';
import { Add as AddIcon, Close as CloseIcon } from '@mui/icons-material';
import { useCaseFieldData, useCaseFieldDispatch } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';
import type { AntibioticOrder } from '../../../../../services/MedNecService/types/medNecTypes';

interface AntibioticGridProps {
  mode: FieldMode;
}

const AntibioticGrid: React.FC<AntibioticGridProps> = ({ mode }) => {
  const data = useCaseFieldData(mode);
  const { dispatchUpdate } = useCaseFieldDispatch(mode);
  const preop = data.preop;

  if (!preop) return null;

  const updateAntibiotic = (index: number, fields: Partial<AntibioticOrder>) => {
    const updated = preop.antibiotics.map((ab, i) => i === index ? { ...ab, ...fields } : ab);
    dispatchUpdate({ preop: { ...preop, antibiotics: updated } });
  };

  const addAntibiotic = () => {
    dispatchUpdate({ preop: { ...preop, antibiotics: [...preop.antibiotics, { drug: '', dose: '', timing: '' }] } });
  };

  const removeAntibiotic = (index: number) => {
    dispatchUpdate({ preop: { ...preop, antibiotics: preop.antibiotics.filter((_, i) => i !== index) } });
  };

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>Antibiotics</Typography>
      {preop.antibiotics.map((ab, i) => (
        <Box key={i} sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 1, mb: 1, alignItems: 'center' }}>
          <TextField size="small" label="Drug" value={ab.drug} onChange={e => updateAntibiotic(i, { drug: e.target.value })} />
          <TextField size="small" label="Dose" value={ab.dose} onChange={e => updateAntibiotic(i, { dose: e.target.value })} />
          <TextField size="small" label="Timing" value={ab.timing} onChange={e => updateAntibiotic(i, { timing: e.target.value })} />
          <IconButton size="small" onClick={() => removeAntibiotic(i)}><CloseIcon fontSize="small" /></IconButton>
        </Box>
      ))}
      <IconButton size="small" onClick={addAntibiotic} sx={{ mb: 1.5 }}><AddIcon fontSize="small" /></IconButton>
    </>
  );
};

export default AntibioticGrid;
